<template>
<div class="absolute" ref="divSize">
	<custom-popover ref="popover" :style="{left: left + 'px', top: (top + 8) + 'px' }" @close="$emit('close')" :backdrop="true">
		<div class="select-variable-popover" :class="{ 'has-changes': hasChanges , 'move-left' : moveLeft}">
			<variable-selector class="variable-list"
				:title="$t('editor-expression.var-title1')"
				:variable-groups="$store.getters.variableGroups"
				:selected-variable-name="variable ? variable.name : null"
				:show-values=true
				@variable-name-changed="onVariableNameChanged"
			/>
			<div style="display: flex; flex-direction: column">
				<variable-format-selector
					v-if="selectedVariable && variable"
					class="variable-format"
					:variable="variable"
					:format="selectedVariable.formatting"
					@format-changed="onFormatChanged"				
				/>
				<!-- <div style="flex: 1 1 auto; overflow: auto">stretch<br><br>stretch<br><br>stretch<br><br>stretch<br><br>stretch<br><br>stretch<br><br>stretch<br><br>stretch<br><br></div> -->
				<div class="save-footer" :class="{ 'can-save': hasChanges }">
					<div class="cancel" @click="onClose">
						{{$t('editor-expression.cancel')}} 
						<i class="fa-light fa-times"></i>
					</div>
					<div class="save" @click="onSave">
						{{$t('editor-expression.save')}} 
						<i class="fa-light fa-check"></i>
					</div>
				</div>
			</div>
		</div>
	</custom-popover>
</div>
</template>

<script>
import VariableSelector from "@/components/VariableSelector";
import VariableFormatSelector from "@/components/VariableFormatSelector";
import CustomPopover from "@/components/CustomPopover";
export default {
  name: "selectVariablePopover",
  props: {
		variableInstance: { type: Object },
		top: Number,
		left: Number,
		moveLeft: Boolean
		// optional: this is the variable in use, containing the name and format
  },
  data() {
    return {
			selectedVariable: null,
			hasChanges: false,
		}
	},
	methods: {
		onSave () {
			if (!this.hasChanges) return
			// this.selectedVariable
			this.$emit('variable-updated', this.selectedVariable)
		},
		onVariableNameChanged (variableName) {
			this.hasChanges = true
			this.selectedVariable = { name: variableName, format: '' }
			// this.onVariableUpdated()
		},
		onFormatChanged (format) {
			this.selectedVariable.format = format
			this.hasChanges = true
			// this.onVariableUpdated()
		},
		onClose () {
			this.$emit('close')
		},

	},
	computed: {
		variable () {
			// return the actual variable, not the instance
			if (this.selectedVariable) return this.$store.getters.combinedVariables[this.selectedVariable.name]
			else return null
		}
	},
	watch: {
		variableInstance: {
			immediate: true,
			handler (variable) {
				if (variable) this.selectedVariable = {...variable}
			}
		}
	},
	components: {
		VariableSelector,
		VariableFormatSelector,
		CustomPopover
	},

}
</script>

<style lang="less">
.absolute{
	position: absolute;
	top: 10px;
}
.custom-popover {

	position: fixed;
	z-index: 102;
	.select-variable-popover {
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.25);
		position: fixed;
		width: 300px;
		top: 70px;		
		// left: calc(100% - 388px);
		left: calc(100% - 388px + 68px);
		background: var(--charcoal);
		min-width: 250px;
		overflow: auto;
		max-height: calc(100% - 85px);
		border-radius: var(--standard-border-radius);

		&::-webkit-scrollbar { //Removing the native scrollbar, but keeping the functionality.
			display: none;
		}		
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */

		#variableFormatSelector .format-content {
			max-height: 230px;
		}

		&.has-changes {
			#variableFormatSelector {
				padding-bottom: 0px;
				.format-content {
					max-height: 190px;
				}
			}
		}
	}

	.variable-list {
		width: 300px;
		position: relative;
		padding-top: 10px;
		.variable-list-wrapper {
			max-height: 200px;
		}
	}
	// .variable-selector{
	// 	background: var(--charcoal);
	// 	color: var(--alabaster);
	// }
	.variable-format {
		width: 300px;
		padding: 0px 0;
		position: relative;
		background: #f1f1f1;
		flex-grow: 1;
		overflow: hidden;
	}
}

.select-variable-popover.move-left{
	left: calc(100% - 590px);
}
	
</style>


